import ProgressRing from "../../../components/ui/ProgressRing";
import { goalValueIn } from "../../../lib/dayGoals";

function computeRate(goals, values) {
  if (!goals || goals.length === 0) return 0;
  let totalCompletion = 0;
  let counted = 0;
  for (const g of goals) {
    const target = g.goalValue || 0;
    if (target <= 0) continue;
    const v = goalValueIn(values, g);
    totalCompletion += Math.min(100, (v / target) * 100);
    counted++;
  }
  return counted === 0 ? 0 : Math.round(totalCompletion / counted);
}

export default function DayCompletionRing({ goals, values }) {
  const rate = computeRate(goals, values);
  return <ProgressRing value={rate} size={120} stroke={10} />;
}
